import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FormControl, FormGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faX } from '@fortawesome/pro-solid-svg-icons';

export class SidebarSearch extends React.Component {
  static propTypes = {
    additionalClasses: PropTypes.string,
    children: PropTypes.node,
    forwardedRef: PropTypes.object,
    icon: PropTypes.oneOf([PropTypes.object, PropTypes.string]),
    inputClassName: PropTypes.string,
    inputProps: PropTypes.object,
    newDesignSystem: PropTypes.bool,
    placeholder: PropTypes.string,
    size: PropTypes.string,
    static: PropTypes.bool,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func,
  };

  static defaultProps = {
    newDesignSystem: false,
    size: '1x'
  };

  render() {
    const {
      additionalClasses,
      icon,
      inputProps,
      newDesignSystem,
      placeholder,
      size,
      value,
      onChange,
      onClear
    } = this.props;

    const hasValue = value && value !== '';

    const containerClasses = classNames(
      { static: this.props.static },
      { 'ds-search-input': newDesignSystem, 'search-container': !newDesignSystem, 'has-filters': hasValue },
      additionalClasses
    );

    return (
      <div className={containerClasses} ref={this.props.forwardedRef}>
        <FormGroup className="with-icon">
          <div className="icon search-icon">
            <FontAwesomeIcon icon={icon || faSearch} size={size}/>
          </div>
          <FormControl
            autoComplete="off"
            className={this.props.inputClassName}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            {...inputProps}
          />
          {this.props.children}
          {onClear && hasValue && (
            <FontAwesomeIcon
              className="clickable icon search-icon py-1"
              fixedWidth
              icon={faX}
              onClick={onClear}
            />
          )}
        </FormGroup>
      </div>
    );
  }
}

export default React.forwardRef((props, ref) => <SidebarSearch {...props} forwardedRef={ref} />);
